import React from 'react';
import Button from './Button';

export interface ListingImagePreviewItem {
  id: string;
  src: string;
  name?: string;
}

export interface ListingImagePreviewGridProps {
  items: ListingImagePreviewItem[];
  onRemove: (id: string) => void;
  title?: string;
}

/**
 * Thumbnail grid for selected listing images before upload/submit.
 */
const ListingImagePreviewGrid: React.FC<ListingImagePreviewGridProps> = ({
  items,
  onRemove,
  title = 'Seçilen Fotoğraflar',
}) => {
  if (items.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 className="fw-semibold mb-2">{title}</h6>
      <div className="d-flex flex-wrap gap-3">
        {items.map((item, index) => (
          <div
            key={item.id}
            className="position-relative rounded overflow-hidden border bg-light"
            style={{ width: 120, height: 120 }}
          >
            <img
              src={item.src}
              alt={item.name ?? `Seçilen fotoğraf ${index + 1}`}
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
            />
            <Button
              type="button"
              className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0 d-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28 }}
              onClick={() => onRemove(item.id)}
              aria-label="Fotoğrafı kaldır"
            >
              <i className="fas fa-times" aria-hidden="true" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListingImagePreviewGrid;
